const DUO_CODE_SCRIM_TOP_CLASS = 'scrim-top';
const DUO_CODE_SCRIM_BOTTOM_CLASS = 'scrim-bottom';
const DUO_CODE_SCRIM_OFFSET = 16;

export { DUO_CODE_SCRIM_BOTTOM_CLASS, DUO_CODE_SCRIM_OFFSET, DUO_CODE_SCRIM_TOP_CLASS };
